// extracted by mini-css-extract-plugin
export var amountPaidColumn = "_ha-6";
export var emphasizeQuantity = "_ha-3";
export var flatBottomCorners = "_ha-5";
export var productImage = "_ha-0";
export var quantityContainer = "_ha-2";
export var tooltip = "_ha-1";
export var wrapAndEllipsesOverflow = "_ha-4";